import React from 'react';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { AppContext } from '/@/app/AppContext';
import useTheme from '@mui/material/styles/useTheme';
import { styled } from '@mui/material/styles';
import { Box, Typography, TextField, Tooltip} from '@mui/material';
import { numberOrNull } from '/@/app/utils';
//
import InputAdornment from '@mui/material/InputAdornment';
import HelpIcon from '@mui/icons-material/Help';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
//
import { AudioPlayer } from '/@/app/components/AudioPlayer';


export const MeasurementItem = styled(Box)(({ theme }) => ({
    ...theme.typography.body2,
    margin: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,

    // content to bottom,
    // so it will align with neighboring items on wide screens
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexFlow: 'column nowrap',
}));

//
// Can create common class with `LabTestView/Measurement` (which is complex!),
// but don't do this until absolutely necessary.
//
export const Value = observer(({ mState, sx }) => {
    const theme = useTheme();

    const colorFromSaveState = (saveState) => {
        let color = {
            "unsaved": "rgba(100,100,255,0.1)",
            "verified": "rgba(100,255,100,0.1)",
            "error": "rgba(255,0,0,0.1)",
            "saved": "white",
        }[saveState];
        if (color === undefined) {
            color = "white";
        }
        if (saveState === "saved" && mState.value !== mState.automaticValue) {
            color = "rgba(255, 255, 0, 0.1)";
        }
        return color;
    }

    // keep last dot on user input
    const [textValue, textValueSet] = React.useState(null);

    const onChange = (event) => {
        // clean value
        let value = event.target.value;
        value = value.replace(/[^0-9., ]/g, '');  // clear invalid symbols
        value = value.replace(/,/g, '.');  // comma to dot
        value = value.replace(/(\..*)\./g, '$1');  // only one dot allowed
        textValueSet(value);
        mState.setInputValue(value);  // allows editing.
    }

    // Mark optimal / non optimal
    let adornment = (
        <InfoOutlinedIcon sx={{ color: "transparent" }} />  // placeholder
    )
    if (mState.value) {
        adornment = <CheckCircleIcon sx={{ color: "#dfdfdf" }} />
    }

    return (
        <Box sx={{ ...sx }}>
            <Typography
                variant="body1"
                component="div"
                sx={{
                    lineHeight: '1.2',  // it's actually a header - make compact
                    marginBottom: '5px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'stretch',
                    alignItems: 'center',
                    width: '100%',
                }}

                gutterBottom
            >
                {mState.caption}
            </Typography>
            <TextField
                label=""
                variant="outlined"
                value={
                    textValue ? textValue :
                        (mState.value !== null
                            ? Math.round(mState.value * 1000) / 1000
                            : ""
                        )
                }
                onKeyDown={onChange}
                onChange={onChange}
                error={mState.saveState === "error"}
                sx={{
                    width: "100%",
                    input: {
                        textAlign: 'center',
                        backgroundColor: colorFromSaveState(mState.saveState),
                        borderRadius: '15px',  // magic number to match the shape of the outlined input
                        pr: '20px',
                        pl: '60px',
                    },
                    '& .MuiFormHelperText-root': { textAlign: 'right', paddingRight: '40px' }, // helper text
                    'input.Mui-disabled': { backgroundColor: '#f5f7fb' }, // ?? label hides when this is set
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">{adornment}</InputAdornment>
                    ),
                }}
            />
        </Box>
    )
});
